// extracted by mini-css-extract-plugin
export default {"isLoading":"Loader_isLoading__1vCPl"};